import debounce from 'lodash/debounce';
import Api from '../../api/axios';
import { getSelections } from '../../actions/configurator/optionActions';
import { getConfig } from '../../config';
import toCamelCase from '../../utils/camelCase';
import { verifySelectedSkuForPla } from '../../utils/plaConfigurationUtils';
import { Utils } from '../../utils/urlUtils';

export const createConfiguration = (
  selections, productId, siteId, zipcode, additionalDetails,
  mainImageUrl, sku, storeId
) => {
  const json = {
    siteId,
    zipcode: zipcode.zipcode,
    productId,
    selections: selections.map((selection) => ({
      optionId: selection.optionId,
      choiceValue: selection.choiceId,
      choiceName: selection.choiceValue,
      optionType: selection.optionType,
      optionTags: selection.optionTags,
    })),
    additionalDetails: additionalDetails && JSON.stringify(additionalDetails),
    mainImageUrl,
    storeId: Number(storeId),
  };
  if (Utils.hasPlaGuid()) {
    verifySelectedSkuForPla(json, sku);
  }

  const url = `${getConfig()?.customBaseUrl}/countertops/api/createconfiguration`;

  return Api().post(url, json);
};

// Debounced pricing POST helper (resolves all pending callers with the latest response)
const postPricing = (url, payload) => Api().post(url, payload).then((response) => toCamelCase(response));

let pendingPricingResolvers = [];
let pendingPricingRejectors = [];
const debouncedPostPricing = debounce((url, payload) => {
  postPricing(url, payload)
    .then((result) => {
      pendingPricingResolvers.forEach((resolver) => resolver(result));
      pendingPricingResolvers = [];
      pendingPricingRejectors = [];
    })
    .catch((err) => {
      pendingPricingRejectors.forEach((rejector) => rejector(err));
      pendingPricingResolvers = [];
      pendingPricingRejectors = [];
    });
}, 1200, { leading: false, trailing: true });

export const configuratorPricing = (data, storeNumber, selectedSku) => {
  const {
    configurator: {
      options,
      choices,
    },
    countertops: {
      availableSkus,
    },
    config: stateConfig
  } = data.getState();

  const payload = {
    ...data,
    Choices: getSelections(choices, options, storeNumber, selectedSku),
    availableSkus,
    selectedSku,
    storeId: storeNumber,
  };

  const url = `${stateConfig?.eleanorBaseUrl}/api/pricing/configurator/basetableschoicepricing`;

  // Debounced call: all callers within the debounce window get resolved with the latest response
  return new Promise((resolve, reject) => {
    pendingPricingResolvers.push(resolve);
    pendingPricingRejectors.push(reject);

    debouncedPostPricing(url, payload);
  });
};
